import React, { useState } from "react";
import { Accordion, Grid, Icon, Label, List, Menu, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css";

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";

export enum budgetPlanMenuTab {
  TAB1 = `Locating Income Sources`,
  TAB2 = `Reverse Mortgage`,
  TAB3 = `Credit Review`, 
  TAB4 = `Credit Score vs Report`
}

export const BudgetPlanLearnMore: React.FC = () => {
  const [activeLearnMoreMenuItem, setActiveLearnMoreMenuItem] = useState(budgetPlanMenuTab.TAB1);
  const [activeAccordionIndexes] = useState([0,1,2,3,4]);


  const renderAccordionUnderstanding = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} > 
        <p className={styles.learnMoreAccordionText} >
          Living on a fixed income makes it difficult to juggle unexpected expenses. Older adults are now filing for
          bankruptcy more frequently and piling up credit card charges, home equity debt, and life insurance loans. 
          Nearly half of older adults who end up in bankruptcy say that they filed
          because of a medical reason.
          <br/><br/>
        <span className={styles.learnMoreAccordionTextEmphasis} >
          Investigating these options can help maximize the older adult's financial situation and help to provide 
          financial security for the rest of their years.</span></p>
      </Segment>
      </>
    );
  };
  const displayActiveMenuSection = () => {
      switch(activeLearnMoreMenuItem) {
        case budgetPlanMenuTab.TAB1:  
          return renderMenuTab1();
        case budgetPlanMenuTab.TAB2:  
          return renderMenuTab2();
        case budgetPlanMenuTab.TAB3:  
          return renderMenuTab3();
        case budgetPlanMenuTab.TAB4:  
          return renderMenuTab4();
    }
  };
  const renderMenuTab1 = () => {
    return (
      <>
      <Grid stackable doubling columns="equal" padded>
        <Grid.Column >
          <p className={styles.learnMoreAccordionTextEmphasis} style={{marginTop: '1.5rem'}} >
            <br/>It is important to identify all sources of income to which the older adult is entitled and 
            make sure they are receiving this income. </p>
          <p className={styles.learnMoreAccordionText}>
            <br/> In general, the average worker can expect a retirement benefit that represents about 40% of his 
            or her average lifetime earnings, leaving a large gap to fill with pensions and savings. </p>
        </Grid.Column>
        <Grid.Column >
          <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
            <List.Header className={styles.learnMoreBulletedListHeader} >Examples of Extra Income Sources:</List.Header>
            <>
              <List.Item description="Social Security" />
              <List.Item description="Veteran Benefits" />
              <List.Item description="Pensions" />
              <List.Item description="Annuities" />
              <List.Item description="Real Estate and Trusts" />
              <List.Item description="Individual Retirement Accounts" style={{bottomBorder: "none"}}/>
            </>
          </List>
        </Grid.Column>
      </Grid>
      </>
    );
  };
  const renderMenuTab2 = () => {
    return (
      <>
      <p className={styles.learnMoreAccordionText} style={{marginTop: '2rem'}} >
        One method of obtaining funds is the reverse mortgage, which <b> allows older homeowners to borrow against
        the equity they have built up in their homes </b> without having to pay the money back until they either 
        move or die. </p>
      <p className={styles.learnMoreAccordionText} >
        In the case of death, the beneficiaries can sell the house, pay off the debt, and split any remaining equity 
        in accordance with the older adult's legal documents. </p>
      <p className={styles.learnMoreAccordionText} style={{marginBottom: '3rem'}} >
        <b> The primary advantage of such a mortgage is that it allows the older adult to continue to live 
        independently. </b> The loan amount can be taken as a lump sum, a line of credit, or as a fixed monthly 
        payment and there are no restrictions on how the money is spent.
      </p>
      </>
    );
  };
  const renderMenuTab3 = () => {
    return (
      <>
      <p className={styles.learnMoreAccordionText} style={{marginTop: '2rem'}}  >
        Maintaining a good credit score might not seem like a priority for older adults since it is likely that their 
        days of borrowing money for things like mortgages and car loans are behind them. </p>
      <p className={styles.learnMoreAccordionTextEmphasis} >
        However, good credit is still important for many reasons.</p>
      <p className={styles.learnMoreAccordionText} >
        If the older adult needs to move into a long-term care facility, they may run a credit check. Also, better credit
        scores mean lower interest rates and finance charges on credit cards, which can save the older adult money. </p>
      <p className={styles.learnMoreAccordionText} style={{marginBottom: '3rem'}}  >
        Reviewing this information is an important step of helping the older adult plan for their financial future. </p>
      </>
    );
  };
  const renderMenuTab4 = () => {
    return (
      <>
      <p className={styles.learnMoreAccordionText} style={{marginTop: '2rem'}} >
        It is important to understand the difference in credit scores and credit reports. </p>
      <p className={styles.learnMoreAccordionText} >
        A <b>credit score</b> will give you the numerical score, an explanation of what the score means, and the top 
        four reasons your score was not higher.  </p>
      <p className={styles.learnMoreAccordionText} >
        A <b>credit report</b> has all the specific information used by credit bureaus to determine your score: payment 
        history on each account, public records, and account summaries. </p>
      <p className={styles.learnMoreAccordionText} style={{marginBottom: '3rem'}}  >
        Your scores may vary since each bureau collects its own data. Scores will change as your credit report is continually
        updated. </p>
      </>
    );
  };
  
  const accordions = [
    { key: 'understanding',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Planning for a Safe and Comfortable Financial Future </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionUnderstanding()}/>)
      }
    }
  ];
  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}BudgetPlanInfoOne.png)`, }}>
        <div className={styles.learnMoreModalContent}  >

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

          <div className={styles.learnMoreMenuDiv} >
            <Segment.Group raised className={styles.learnMoreMenuSegmentGroup} >
              <Menu attached='top' tabular color="green" className={styles.learnMoreMenuTab} widths='four'>
                <Menu.Item
                  name={budgetPlanMenuTab.TAB1}
                  active={activeLearnMoreMenuItem === budgetPlanMenuTab.TAB1}
                  onClick={() => setActiveLearnMoreMenuItem(budgetPlanMenuTab.TAB1)}
                />
                <Menu.Item
                  name={budgetPlanMenuTab.TAB2}
                  active={activeLearnMoreMenuItem === budgetPlanMenuTab.TAB2}
                  onClick={() => setActiveLearnMoreMenuItem(budgetPlanMenuTab.TAB2)}
                />
                <Menu.Item
                  name={budgetPlanMenuTab.TAB3}
                  active={activeLearnMoreMenuItem === budgetPlanMenuTab.TAB3}
                  onClick={() => setActiveLearnMoreMenuItem(budgetPlanMenuTab.TAB3)}
                />
                <Menu.Item
                  name={budgetPlanMenuTab.TAB4}
                  active={activeLearnMoreMenuItem === budgetPlanMenuTab.TAB4}
                  onClick={() => setActiveLearnMoreMenuItem(budgetPlanMenuTab.TAB4)}
                />
              </Menu>
              <Segment attached='bottom' raised className={styles.learnMoreMenuTabbedSegment} >
                {displayActiveMenuSection()}
              </Segment>
            </Segment.Group>
          </div> 
    
        </div>
      </Segment>    
    </>
    );  
};
